module.exports = __webpack_public_path__ + "img/bianzu_pt.7dcde9cb.png";